import { closeBtn } from 'icons/close';

import './launcherIcon.scss';

export const LauncherIconTemplate = (model) => {
	const { calloutMessage = '', url } = model;

	/* html */
	const closedCallout = `
		<div id="engtClosedCallout" class="engt-closed-callout-hidden">
			<div class="engt-closed-callout-btn">${closeBtn('#000', '24')}</div>
			<div id="engtCalloutText" class="engt-closed-callout-text">${calloutMessage}</div>
		</div>`;

	/* html */
	const html = `
		${closedCallout}
		<img 
			tabindex="0" 
			src="${url}"
			id="engtLauncherIcon"  
			class="engt-launcher-icon engt-launcher-icon-animate engt-tab-selectable" 
			alt="bot-launch-icon"
			loader="lazy"
		/>
		<div class="engt-notification-badge">
			<notification-badge></notification-badge>
		</div>
    `;

	return html;
};
